import React, { useState } from "react";
import InputField from "../InputField";
import SubmitButton from "../SubmitButton";

export default function ChangePasswordOldForm({ onSubmit }) {

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirm, setNewPasswordConfirm] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError("");

    if (newPassword !== newPasswordConfirm) {
      setError("رمز عبور جدید و تکرار آن یکسان نیست.");
      return;
    }

    await onSubmit({
      oldPassword,
      newPassword,
      newPasswordConfirm,
    });
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-4">

      <InputField
        label="رمز عبور فعلی"
        type="password"
        value={oldPassword}
        onChange={(e) => setOldPassword(e.target.value)}
      />

      <InputField
        label="رمز عبور جدید"
        type="password"
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
      />

      <InputField
        label="تکرار رمز عبور جدید"
        type="password"
        value={newPasswordConfirm}
        onChange={(e) => setNewPasswordConfirm(e.target.value)}
      />

      {error && <p className="text-red-600 text-sm">{error}</p>}

      <SubmitButton text="تغییر رمز عبور" />

    </form>
  );
}
